<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import User from '@/components/widgets/user'
import UserService from '@/services/user'

export default {
  page: {
    title: "Usuários",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, User },
  data() {
    return {
      title: "Usuários",
      users: [],
      searchValue: '',
      selectedUser: {},

      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,
    };
  },
  computed: {
    rows() {
      return this.users.length;
    }
  },
  mounted() {
    this.load(1);
  },
  methods: {
    load(page, hideLoading = false) {
      let loader;
      if (!hideLoading) {
        loader = this.$loading.show();
      }

      UserService.getList(page, this.searchValue).then(res => {
        if (!hideLoading) {
          loader.hide();
        }

        this.users = res.data.data;

        this.count = res.data.count;
        this.currentCount = res.data.currentCount;
        this.currentPage = res.data.currentPage;
        this.totalPages = res.data.totalPages;
        this.perPage = res.data.perPage;
        this.startIndex = res.data.startIndex;
        this.endIndex = res.data.endIndex;
      }).catch(() => {
        if (!hideLoading) {
          loader.hide();
        }
      })
    },
    search() {
      this.load(1);
    },
    onPageChange() {
      this.load(this.currentPage);
    },

    blockUser(item) {
      let loader = this.$loading.show();

      this.$bvModal.hide('modal-confirm-block');

      UserService.blockCustomer(item._id).then(() => {
        loader.hide();

        this.$toast.open('Usuário bloqueado com sucesso');

        this.load();
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao bloquear');
        loader.hide();
      })
    },

    unblockUser(item) {
      let loader = this.$loading.show();

      this.$bvModal.hide('modal-confirm-unblock');

      UserService.unblockCustomer(item._id).then(() => {
        loader.hide();

        this.$toast.open('Usuário desbloqueado com sucesso');

        this.load();
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao desbloquear');
        loader.hide();
      })
    },
    selectUser(item, modal) {
      this.selectedUser = item;

      if (modal === 'block') {
        this.$bvModal.show('modal-confirm-block');
      } else if (modal === 'unblock') {
        this.$bvModal.show('modal-confirm-unblock');
      } else if (modal === 'recover-password') {
        this.$bvModal.show('modal-recover-password');
      } else if (modal === 'show-password') {
        this.$bvModal.show('modal-temp-password');
      }
    },

    recoverPassword(item) {
      let loader = this.$loading.show();

      this.$bvModal.hide('modal-recover-password');

      UserService.recoverPassword(item._id, item.email).then(() => {
        loader.hide();

        this.$toast.open('Recuperação de senha enviada');

        this.load(this.page, true);
      }).catch(() => {
        this.$toast.error('Ocorreu um erro');
        loader.hide();
      })
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-6">
                <div class="position-relative search-input search-box">
                  <form @submit.prevent="search" class="align-items-center">
                    <input
                      type="text"
                      class="form-control"
                      v-model="searchValue"
                      placeholder="Procurar por nome ou e-mail..."
                    />

                    <button type="submit" class="btn btn-rounded btn-outline-primary ml-2">
                      Pesquisar
                    </button>
                  </form>
                </div>
              </div>
            </div>

            <User :users="users" :selectUser="this.selectUser" />
            
            <div class="row justify-content-md-between align-items-md-center mt-4">
              <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>

              <div class="col-xl-5">
                <div class="text-md-right float-xl-right mt-2 pagination-rounded">
                  <b-pagination
                    v-model="currentPage" 
                    :total-rows="count"
                    :per-page="perPage"
                    @input="onPageChange"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-confirm-block"
      title="Bloquear Usuário?"
      title-class="font-18"
      centered
    >
      <p>O acesso desse usuário será bloqueado. Deseja continuar?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-confirm-block')" class="mr-3">Cancelar</b-btn>
        <b-btn variant="danger" @click="blockUser(selectedUser)">Bloquear Usuário</b-btn>
      </div>
    </b-modal>

    <b-modal
      id="modal-confirm-unblock"
      title="Desbloquear Usuário?"
      title-class="font-18"
      centered
    >
      <p>O acesso desse usuário será desbloqueado. Deseja continuar?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-confirm-unblock')" class="mr-3">Cancelar</b-btn>
        <b-btn variant="primary" @click="unblockUser(selectedUser)">Desbloquear</b-btn>
      </div>
    </b-modal>

    <b-modal
      id="modal-recover-password"
      title="Enviar Recuperação de Senha"
      title-class="font-18"
      centered
    >
      <p>Informe o e-mail para receber a solicitação de recuperação da senha</p>

      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <input
              id="email"
              name="email"
              type="email"
              class="form-control"
              v-model="selectedUser.email"
            />
          </div>
        </div>
      </div>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-recover-password')" class="mr-3">Cancelar</b-btn>
        <b-btn variant="primary" @click="recoverPassword(selectedUser)">Confirmar</b-btn>
      </div>
    </b-modal>

    <b-modal
      id="modal-temp-password"
      title="Senha Temporária"
      title-class="font-18"
      centered
    >
      <p>{{selectedUser.temp_password}}</p>

      <div slot="modal-footer">
        <b-btn variant="primary" @click="$bvModal.hide('modal-temp-password')">Fechar</b-btn>
      </div>
    </b-modal>
  </Layout>
</template>

<style lang="scss">
  .search-box form {
    display: flex;
    flex-direction: row;
  }

  .search-box .form-control {
    padding-left: 20px;
  }

  .input-search {
    width: 90%;
  }
</style>